/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Merge_Modal_TitleInputs */



/**
* | output |
* | --- |
* | "Merge Users" |
*
* @param {Vekn_Merge_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_merge_modal_title = /** @type {((inputs?: Vekn_Merge_Modal_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Merge_Modal_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner les utilisateurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar usuarios")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mesclar Usuários")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci Utenti")
	return /** @type {LocalizedString} */ ("Merge Users")
});